import { render, staticRenderFns } from "./singleReport.vue?vue&type=template&id=b062b524&scoped=true&"
import script from "./singleReport.vue?vue&type=script&lang=js&"
export * from "./singleReport.vue?vue&type=script&lang=js&"
import style0 from "./singleReport.vue?vue&type=style&index=0&id=b062b524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b062b524",
  null
  
)

export default component.exports